"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var TextUtils_1 = require("../../Utils/TextUtils");
var QueryField = /** @class */ (function () {
    /**
     * Construye una estructura de representación de un campo y su alias en la sentencia SQL
     *
     * @param FieldName Nombre del campo en base de datos.
     * @param AliasName Alias del campo en la sentencia.
     */
    function QueryField(FieldName, AliasName) {
        this.m_strField = FieldName;
        this.m_strAlias = AliasName;
    }
    /**
     * Nombre del campo en la tabla en base de datos
     *
     * @return Devuelve el nombre real del campo.
     */
    QueryField.prototype.getName = function () {
        return this.m_strField;
    };
    QueryField.prototype.getResolvedName = function () {
        return TextUtils_1.default.isEmpty(this.m_strAlias) ? this.m_strField : this.m_strAlias;
    };
    /**
     * Asigna valor nuevo al nombre del campo
     *
     * @param value Nuevo valor para el nombre del campo.
     */
    QueryField.prototype.setName = function (value) {
        this.m_strField = value;
    };
    /**
     * Alias del campo en la sentencia SELECT
     *
     * @return Devuelve el alias del campo en la sentencia SELECT.
     */
    QueryField.prototype.getAlias = function () {
        return this.m_strAlias;
    };
    /**
     * Asigna valor al alias del campo en la sentencia SELECT.
     *
     * @param value Nuevo valor del alias del campo en la sentencia.
     */
    QueryField.prototype.setAlias = function (value) {
        this.m_strAlias = value;
    };
    return QueryField;
}());
exports.default = QueryField;

//# sourceMappingURL=QueryField.js.map
